import { LoadingLayer } from '../../LoadingLayer';
import { useEffect, useState } from 'react';
import './Admin.css';
import { SideMenuAdmin } from './SideMenuAdmin';
import PropTypes from 'prop-types';

export const fetchAdminReceipts = async (setReceipts) => {
  try {
    const response = await fetch(
      'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/receipts',
      {
        headers: {
          'user-token': localStorage.getItem('id_token'),
        },
      },
    );
    const data = await response.json();
    console.log(data);
    setReceipts(data.Items);
  } catch (error) {
    console.error('Error:', error);
    return error;
  }
};

const updateReceiptStatus = async (receiptId, updatedAt, newStatus) => {
  const data = {
    status: newStatus,
    updated_at: updatedAt,
  };
  await fetch(
    'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/receipts/' + receiptId,
    {
      method: 'POST',
      headers: {
        'user-token': localStorage.getItem('id_token'),
      },
      body: JSON.stringify(data),
    },
  );
};

const STATUS_OPTIONS = [
  { value: 'Sent', label: 'Sent' },
  { value: 'Creating reports', label: 'Creating reports' },
  { value: 'Receipt sent', label: 'Receipt sent' },
];

export const AdminReceiptView = () => {
  const [receipts, setReceipts] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const [statusEdits, setStatusEdits] = useState({});
  const [savingStatus, setSavingStatus] = useState({});

  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage('Loading receipts');
    fetchAdminReceipts(setReceipts).then(() => {
      setIsLoading(false);
    });
  }, []);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getFilteredReceipts = (list) => {
    if (!list || !searchQuery.trim()) return list;
    const q = searchQuery.toLowerCase().trim();
    return list.filter((r) =>
      (r.name || '').toLowerCase().includes(q) ||
      (r.email || '').toLowerCase().includes(q) ||
      (r.accountEmail || '').toLowerCase().includes(q) ||
      (r.status || '').toLowerCase().includes(q),
    );
  };

  const getSortedReceipts = (list) => {
    if (!list || !sortConfig.key) return list;
    return [...list].sort((a, b) => {
      let valA, valB;
      if (sortConfig.key === 'isStudent' || sortConfig.key === 'requireInvoice') {
        valA = a[sortConfig.key] ? 1 : 0;
        valB = b[sortConfig.key] ? 1 : 0;
      } else {
        valA = (a[sortConfig.key] || '').toString().toLowerCase();
        valB = (b[sortConfig.key] || '').toString().toLowerCase();
      }
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortedReceipts = getSortedReceipts(getFilteredReceipts(receipts));

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey)
      return <span style={{ opacity: 0.3, marginLeft: 4 }}>↕</span>;
    return <span style={{ marginLeft: 4 }}>{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  SortIcon.propTypes = {
    columnKey: PropTypes.string.isRequired,
  };

  const handleStatusChange = (receiptId, newStatus) => {
    setStatusEdits((prev) => ({ ...prev, [receiptId]: newStatus }));
  };

  const handleStatusSave = async (receipt) => {
    const newStatus = statusEdits[receipt.id];
    if (!newStatus || newStatus === receipt.status) return;

    setSavingStatus((prev) => ({ ...prev, [receipt.id]: true }));
    try {
      await updateReceiptStatus(receipt.id, receipt.updated_at, newStatus);
      setReceipts((prev) =>
        prev
          ? prev.map((r) =>
              r.id === receipt.id ? { ...r, status: newStatus } : r,
            )
          : prev,
      );
      setStatusEdits((prev) => {
        const next = { ...prev };
        delete next[receipt.id];
        return next;
      });
    } catch (error) {
      alert('Error updating status');
    } finally {
      setSavingStatus((prev) => ({ ...prev, [receipt.id]: false }));
    }
  };

  const downloadCsv = () => {
    if (!receipts || receipts.length === 0) return;

    const esc = (val) => `"${String(val ?? '').replace(/"/g, '""')}"`;

    const headers = [
      'Name',
      'Email',
      'Account Email',
      'Status',
      'Is Student',
      'Require Invoice',
      'Created At',
      'Updated At',
      'Receipt URL',
      'Fiscal Situation URL',
      'Studies Proof URL',
      'Food',
      'Food Allergies',
    ];

    const csvRows = [headers.map(esc).join(',')];

    receipts.forEach((r) => {
      const row = [
        r.name,
        r.email,
        r.accountEmail,
        r.status,
        r.isStudent ? 'Yes' : 'No',
        r.requireInvoice ? 'Yes' : 'No',
        r.created_at,
        r.updated_at,
        r.receipt,
        r.fiscalSituation,
        r.studiesProof,
        r.food,
        r.foodAllergies,
      ].map(esc);
      csvRows.push(row.join(','));
    });

    const csvString = '\uFEFF' + csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'receipts.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenuAdmin />
      <div className="snn-abstract-submission-main-grid-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />

        <section className="snn-expand-grid-4">
          <h1 className="snn-user-home-main-content-header">Receipts</h1>

          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' }}>
            <button
              onClick={downloadCsv}
              disabled={!receipts || receipts.length === 0}
              style={{
                padding: '8px 16px',
                backgroundColor: '#0b6ef6',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              Download CSV{' '}
              <span
                className="material-symbols-outlined"
                style={{ verticalAlign: 'middle', marginLeft: 4 }}
              >
                download
              </span>
            </button>
          </div>

          {/* Search bar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
              <span
                className="material-symbols-outlined"
                style={{
                  position: 'absolute',
                  left: 10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#94a3b8',
                  fontSize: '20px',
                }}
              >
                search
              </span>
              <input
                type="text"
                placeholder="Search by name, email, account email or status..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 12px 10px 36px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#94a3b8',
                    fontSize: '18px',
                    lineHeight: 1,
                    padding: 0,
                  }}
                >
                  ×
                </button>
              )}
            </div>
            {receipts && (
              <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap' }}>
                {sortedReceipts ? sortedReceipts.length : 0} / {receipts.length} receipts
              </span>
            )}
          </div>

          {/* Table */}
          {receipts && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                    <th
                      style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => handleSort('name')}
                    >
                      Name <SortIcon columnKey="name" />
                    </th>
                    <th
                      style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => handleSort('email')}
                    >
                      Email <SortIcon columnKey="email" />
                    </th>
                    <th
                      style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => handleSort('accountEmail')}
                    >
                      Account Email <SortIcon columnKey="accountEmail" />
                    </th>
                    <th
                      style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => handleSort('status')}
                    >
                      Status <SortIcon columnKey="status" />
                    </th>
                    <th
                      style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => handleSort('isStudent')}
                    >
                      Student <SortIcon columnKey="isStudent" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>
                      Invoice
                    </th>
                    <th
                      style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => handleSort('created_at')}
                    >
                      Created At <SortIcon columnKey="created_at" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>
                      Downloads
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', minWidth: '200px' }}>
                      Update Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedReceipts &&
                    sortedReceipts.map((receipt) => {
                      const currentStatus = statusEdits[receipt.id] ?? receipt.status;
                      const hasUnsavedChange =
                        statusEdits[receipt.id] !== undefined && statusEdits[receipt.id] !== receipt.status;
                      const isSaving = savingStatus[receipt.id];

                      return (
                        <tr key={receipt.id} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: '8px 12px', fontWeight: 600 }}>
                            {receipt.name}
                          </td>
                          <td style={{ padding: '8px 12px', fontSize: '13px' }}>
                            {receipt.email}
                          </td>
                          <td style={{ padding: '8px 12px', fontSize: '13px' }}>
                            {receipt.accountEmail}
                          </td>
                          <td style={{ padding: '8px 12px' }}>
                            <span
                              style={{
                                display: 'inline-block',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: 600,
                                backgroundColor:
                                  receipt.status === 'Receipt sent'
                                    ? '#dcfce7'
                                    : receipt.status === 'Creating reports'
                                    ? '#fef3c7'
                                    : '#e0e7ff',
                                color:
                                  receipt.status === 'Receipt sent'
                                    ? '#166534'
                                    : receipt.status === 'Creating reports'
                                    ? '#92400e'
                                    : '#3730a3',
                              }}
                            >
                              {receipt.status}
                            </span>
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                            {receipt.isStudent ? (
                              <span style={{ color: '#166534', fontWeight: 600 }}>Yes</span>
                            ) : (
                              <span style={{ color: '#94a3b8' }}>No</span>
                            )}
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                            {receipt.requireInvoice ? (
                              <span style={{ color: '#166534', fontWeight: 600 }}>Yes</span>
                            ) : (
                              <span style={{ color: '#94a3b8' }}>No</span>
                            )}
                          </td>
                          <td style={{ padding: '8px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}>
                            {receipt.created_at}
                          </td>
                          <td style={{ padding: '8px 12px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                              {receipt.receipt && (
                                <a
                                  href={receipt.receipt}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    color: '#0b6ef6',
                                    textDecoration: 'none',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                  }}
                                >
                                  <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
                                    sim_card_download
                                  </span>
                                  Receipt
                                </a>
                              )}
                              {receipt.fiscalSituation && (
                                <a
                                  href={receipt.fiscalSituation}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    color: '#7c3aed',
                                    textDecoration: 'none',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                  }}
                                >
                                  <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
                                    sim_card_download
                                  </span>
                                  Fiscal Situation
                                </a>
                              )}
                              {receipt.isStudent && receipt.studiesProof && (
                                <a
                                  href={receipt.studiesProof}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    color: '#059669',
                                    textDecoration: 'none',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                  }}
                                >
                                  <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
                                    sim_card_download
                                  </span>
                                  Studies Proof
                                </a>
                              )}
                              {!receipt.receipt && !receipt.fiscalSituation && (
                                <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '8px 12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <select
                                value={currentStatus}
                                onChange={(e) => handleStatusChange(receipt.id, e.target.value)}
                                style={{
                                  padding: '4px 6px',
                                  fontSize: '12px',
                                  borderRadius: '4px',
                                  border: '1px solid #ccc',
                                  flex: 1,
                                }}
                              >
                                {STATUS_OPTIONS.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </select>
                              <button
                                onClick={() => handleStatusSave(receipt)}
                                disabled={!hasUnsavedChange || isSaving}
                                style={{
                                  padding: '4px 10px',
                                  fontSize: '12px',
                                  borderRadius: '4px',
                                  border: 'none',
                                  backgroundColor: hasUnsavedChange ? '#f59e0b' : '#22c55e',
                                  color: '#fff',
                                  cursor: hasUnsavedChange ? 'pointer' : 'not-allowed',
                                  opacity: hasUnsavedChange ? 1 : 0.5,
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {isSaving ? '...' : hasUnsavedChange ? 'Save' : '✓'}
                              </button>
                            </div>
                            {hasUnsavedChange && (
                              <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600, marginTop: '2px', display: 'block' }}>
                                ● Unsaved
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
